import { render, staticRenderFns } from "./DatabasesTable.vue?vue&type=template&id=ebfa4a24&"
import script from "./DatabasesTable.vue?vue&type=script&lang=js&"
export * from "./DatabasesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebfa4a24')) {
      api.createRecord('ebfa4a24', component.options)
    } else {
      api.reload('ebfa4a24', component.options)
    }
    module.hot.accept("./DatabasesTable.vue?vue&type=template&id=ebfa4a24&", function () {
      api.rerender('ebfa4a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Mysql/Databases/DatabasesTable.vue"
export default component.exports